module.exports = __webpack_public_path__ + "img/gb815.prt.7385aed2.jpg";